import { EmployeesDuplicatesTableImpl } from './EmployeesDuplicatesTableImpl'

export default function EmployeesDuplicatesTable () {
  return <EmployeesDuplicatesTableImpl />
}
